/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Livid_Cod_SewInputs */

const en_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete payment`)
};

const id_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesaikan pembayaran`)
};

const ms_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengkapkan bayaran`)
};

const ca_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar el pagament`)
};

const cs_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončit platbu`)
};

const da_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gennemfør betaling`)
};

const de_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung abschließen`)
};

const et_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lõpeta makse`)
};

const es_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar el pago`)
};

const fr_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finaliser le paiement`)
};

const hr_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Završi plaćanje`)
};

const it_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa pagamento`)
};

const lv_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabeigt maksājumu`)
};

const lt_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Užbaigti mokėjimą`)
};

const hu_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fizetés befejezése`)
};

const nl_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaling voltooien`)
};

const nb_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullfør betalingen`)
};

const pl_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokończ płatność`)
};

const pt_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizar pagamento`)
};

const ro_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizează plata`)
};

const sk_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončiť platbu`)
};

const sl_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izvedba plačila`)
};

const fi_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suorita maksu`)
};

const sv_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slutför betalning`)
};

const vi_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tất thanh toán`)
};

const tr_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödemeyi tamamla`)
};

const el_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ολοκλήρωση πληρωμής`)
};

const bg_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завършване на плащането`)
};

const ru_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершить оплату`)
};

const sr_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обави плаћање`)
};

const uk_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершити оплату`)
};

const ka_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გადახდის დასრულება`)
};

const hi_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेमेंट पूरा करें`)
};

const th_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชำระเงินให้เสร็จสมบูรณ์`)
};

const ko_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 완료`)
};

const zh_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成付款`)
};

const zh_tw_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成付款`)
};

const ja_quick_livid_cod_sew = /** @type {(inputs: Quick_Livid_Cod_SewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払いを完了する`)
};

/**
* | output |
* | --- |
* | "Complete payment" |
*
* @param {Quick_Livid_Cod_SewInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const quick_livid_cod_sew = /** @type {((inputs?: Quick_Livid_Cod_SewInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Livid_Cod_SewInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_quick_livid_cod_sew(inputs)
	if (locale === "ms") return ms_quick_livid_cod_sew(inputs)
	if (locale === "ca") return ca_quick_livid_cod_sew(inputs)
	if (locale === "cs") return cs_quick_livid_cod_sew(inputs)
	if (locale === "da") return da_quick_livid_cod_sew(inputs)
	if (locale === "de") return de_quick_livid_cod_sew(inputs)
	if (locale === "et") return et_quick_livid_cod_sew(inputs)
	if (locale === "es") return es_quick_livid_cod_sew(inputs)
	if (locale === "fr") return fr_quick_livid_cod_sew(inputs)
	if (locale === "hr") return hr_quick_livid_cod_sew(inputs)
	if (locale === "it") return it_quick_livid_cod_sew(inputs)
	if (locale === "lv") return lv_quick_livid_cod_sew(inputs)
	if (locale === "lt") return lt_quick_livid_cod_sew(inputs)
	if (locale === "hu") return hu_quick_livid_cod_sew(inputs)
	if (locale === "nl") return nl_quick_livid_cod_sew(inputs)
	if (locale === "nb") return nb_quick_livid_cod_sew(inputs)
	if (locale === "pl") return pl_quick_livid_cod_sew(inputs)
	if (locale === "pt") return pt_quick_livid_cod_sew(inputs)
	if (locale === "ro") return ro_quick_livid_cod_sew(inputs)
	if (locale === "sk") return sk_quick_livid_cod_sew(inputs)
	if (locale === "sl") return sl_quick_livid_cod_sew(inputs)
	if (locale === "fi") return fi_quick_livid_cod_sew(inputs)
	if (locale === "sv") return sv_quick_livid_cod_sew(inputs)
	if (locale === "vi") return vi_quick_livid_cod_sew(inputs)
	if (locale === "tr") return tr_quick_livid_cod_sew(inputs)
	if (locale === "el") return el_quick_livid_cod_sew(inputs)
	if (locale === "bg") return bg_quick_livid_cod_sew(inputs)
	if (locale === "ru") return ru_quick_livid_cod_sew(inputs)
	if (locale === "sr") return sr_quick_livid_cod_sew(inputs)
	if (locale === "uk") return uk_quick_livid_cod_sew(inputs)
	if (locale === "ka") return ka_quick_livid_cod_sew(inputs)
	if (locale === "hi") return hi_quick_livid_cod_sew(inputs)
	if (locale === "th") return th_quick_livid_cod_sew(inputs)
	if (locale === "ko") return ko_quick_livid_cod_sew(inputs)
	if (locale === "zh") return zh_quick_livid_cod_sew(inputs)
	if (locale === "zh-tw") return zh_tw_quick_livid_cod_sew(inputs)
	if (locale === "ja") return ja_quick_livid_cod_sew(inputs)
	return en_quick_livid_cod_sew(inputs)
});